// export const apiUrl = 'https://api.mykoodoo.com/sa/';
export const apiUrl = 'https://mykoodoo.com/api/sa/';
// export const apiUrl = 'http://192.168.1.151:4751/sa/';

export const prefix = '/web-order';

export const googleCloudApiKey = "AIzaSyAcXc3dCqZwxETpxBaw-4lTBxS482FvhwU";